import React from "react";
import { useTranslation } from "react-i18next";

function FooterSection() {

    var { t } = useTranslation();

    var footerBackgroundColor = "#111"; // very dark gray
    var footerTextColor = "#ffffff";
    var footerLinkColor = "#cccccc";
    var footerLinkHoverColor = "#ffffff";

    return (
        <footer
            className="uk-section"
            style={{
                backgroundColor: footerBackgroundColor,
                color: footerTextColor,
                paddingTop: "60px",
                paddingBottom: "40px"
            }}
        >
            <div className="uk-container">
                <div
                    className="uk-grid uk-child-width-1-4@s"
                    data-uk-grid
                    style={{ marginBottom: "40px" }}
                >

                    {/* Column 1: Cities */}
                    <div>
                        <h4 className="uk-heading-bullet" style={{ color: footerTextColor }}>
                            {t("ui.footer.cities.label")}
                        </h4>
                        <ul className="uk-list">
                            <li>
                                <a href="/cities/astana" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.tse")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/semipalatinsk" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.spl")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/karaganda" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.krg")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/almaty" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.ver")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/aktau" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.shv")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/shymkent" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.chm")}
                                </a>
                            </li>
                            <li>
                                <a href="/cities/turkistan" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("company.cities.trk")}
                                </a>
                            </li>
                            
                        </ul>
                    </div>

                    {/* Column 2: Universities */}
                    <div>
                        <h4 className="uk-heading-bullet" style={{ color: footerTextColor }}>
                            {t("ui.footer.universities.label")}
                        </h4>
                        <ul className="uk-list">
                            <li>
                                <a href="https://nu.edu.kz/admissions" target="_blank" rel="noopener noreferrer" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.universities.nu")}
                                </a>
                            </li>
                            <li>
                                <a href="https://www.coventry.ac.uk/kazakhstan/astana/" target="_blank" rel="noopener noreferrer" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.universities.coventry")}
                                </a>
                            </li>
                            <li>
                                <a href="https://abu.edu.kz/" target="_blank" rel="noopener noreferrer" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.universities.abu")}
                                </a>
                            </li>
                            <li>
                                <a href="https://astanait.edu.kz/" target="_blank" rel="noopener noreferrer" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.universities.aitu")}
                                </a>
                            </li>
                            <li>
                                <a href="https://enu.kz/" target="_blank" rel="noopener noreferrer" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.universities.enu")}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 3: Partners & Investment */}
                    <div>
                        <h4 className="uk-heading-bullet" style={{ color: footerTextColor }}>
                            {t("ui.footer.invest.label")}
                        </h4>
                        <ul className="uk-list">
                            <li>
                                <a href="/investment/visa-a5" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.invest.visa-a5")}
                                </a>
                            </li>
                            <li>
                                <a href="/investment/open-company" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.invest.open_company")}
                                </a>
                            </li>
                            <li>
                                <a href="/investment/aifc" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.invest.aifc")}
                                </a>
                            </li>
                            <li>
                                <a href="/investment/special-zones" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.invest.sez")}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 4: For User */}
                    <div>
                        <h4 className="uk-heading-bullet" style={{ color: footerTextColor }}>
                            {t("ui.footer.for_user.label")}
                        </h4>
                        <ul className="uk-list">
                            <li>
                                <a href="/travel-overview" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.for_user.tourist_visa")}
                                </a>
                            </li>
                            <li>
                                <a href="/work-overview" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.for_user.professional_visa")}
                                </a>
                            </li>
                            <li style={{ height: "20px" }}></li>
                            <li>
                                <a href="/terms-of-service" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.for_user.terms")}
                                </a>
                            </li>
                            <li>
                                <a href="/privacy-policy" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.for_user.privacy")}
                                </a>
                            </li>
                        </ul>
                        <h4 className="uk-heading-bullet" style={{ color: footerTextColor }}>
                            Partners
                        </h4>
                        <ul className="uk-list">
                            <li>
                                <a href="/partners/mekgraj" style={{ color: footerLinkColor, textDecoration: "none" }}>
                                    {t("ui.footer.invest.mekgraj")}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Separator line */}
            <hr style={{ borderColor: "#333", borderWidth: "1px", width: "100vw", marginLeft: "calc(-50vw + 50%)" }} />

            <div className="uk-container">
                {/* Bottom line */}
                <div
                    className="uk-text-center"
                    style={{
                        marginTop: "20px",
                        fontSize: "0.9rem",
                        color: "#bbb"
                    }}
                >
                    <span style={{
                        whiteSpace: 'pre-line',
                        lineHeight: '1.5',
                        display: 'block',
                        textAlign: 'left'
                    }}> 
                        {t("company.sign")}
                    </span>
                </div>
            </div>

            {/* Hover effect */}
            <style>
                {`
                    footer a:hover {
                        color: ${footerLinkHoverColor};
                    }
                `}
            </style>
        </footer>
    );
}

export default FooterSection;
